import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  Col,
  Dropdown,
  Form,
  Layout,
  Input,
  Modal,
  Menu,
  Row,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import {
  CheckOutlined,
  EllipsisOutlined,
  InfoCircleOutlined,
  PlusOutlined,
  SaveOutlined,
} from '@ant-design/icons';
import { v4 as uuid } from 'uuid';
import {
  CardSection,
  ExportCSV,
  FormLabel,
  HeaderTitle,
  InfoButton,
  InputInteger as InputNumber,
  Label,
  Locker,
  Loading,
  ScreenMask,
  SelectProduct,
  SelectWarehouse,
  SecondaryButton,
  message,
} from 'components/common';
import SelectLotUomDialog from 'components/Inventory/Add/SelectLotUom';
import SearchSelect2 from 'components/Inventory/MoveMerge/SearchSelect2';
import { FormItemLeft, LockerBox } from 'components/Inventory/MoveMerge/style';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  COMMON_MSG_DEFAULT_DISPLAY_DURATION,
  HTTP_STATUS_OK,
  LOADING_ICON_SIZE1,
} from 'constants/config';
import {
  addWarehouseBatchTransfer,
  addWarehouseBatchTransferLine,
  editWarehouseBatchTransfer,
  fetchWarehouseBatchTransferDetail,
} from 'services/inventory';
import { fetchProducts } from 'services/product';
import { getProfileSettingValue } from 'utils';
import TransferLineGrid, { exportColumns, mapCsvData } from '../WarehouseTransferWmsList/TransferLineGrid';
import { editTransferBatch, isErrorExist, submitTransferBatch } from '../WarehouseTransferWmsList';
import ToDoListInputer from './ToDoListInputer';

const WHTransferReceive = () => {
  const { useState } = React;
  const { Text } = Typography
  const [DLocationLock6, setDLocationLock6] = useState(false);
  const [SLocationLock6, setSLocationLock6] = useState(false);
  const [batch, setBatch] = useState<StringKAnyVPair>({});
  const [batchNumber, setBatchNumber] = useState('');
  const [batchNote, setBatchNote] = useState('');
  const [destWHLocked, setDestWHLocked] = useState(false);
  const [gridVersion, setGridVersion] = useState(0);
  const [identifierLocked, setIdentifierLocked] = useState(false);
  const [inited, setInited] = useState(false);
  const [lineNotedLocked, setLineNoteLocked] = useState(false);
  const [lotEnable, setLotEnable] = useState(false);
  const [lockScreen, setLockScreen] = useState(false);
  const [lotUomInfo, setLotUomInfo] = useState<{ uom : string, uomRate : number, lotNumber : string }>();
  const [qtyRef, setQtyRef] = useState(0);
  const [quantityLock6, setQuantityLock6] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState('');
  const [sourceWHLocked, setSourceWHLocked] = useState(false);
  const [selectLotUomDialogVisible, setSelectLotUomDialogVisible] = useState(false);
  const [selectedProduct6, setSelectedProduct6] = useState<ProductRow>();
  const [selectedSWarehouse6, setSelectedSWarehouse6] = useState<StringKAnyVPair>();
  const [selectedDWarehouse6, setSelectedDWarehouse6] = useState<StringKAnyVPair>();
  const [toDoList,setToDoList] = useState<StringKAnyVPair[]>([]);
  const [toDoListInputerVisible, setToDoListInputerVisible] = useState(false);
  const [transferNumber, setTransferNumber] = useState(0);
  const [uomEnable, setUomEnable] = useState(false);
  const [recvForm] = Form.useForm();
  const history = useHistory();

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 },
    },
    wrapperCol: {
      sm: { span: 16 },
    },
  };

  // eslint-disable-next-line
  const checkBatchNumberFromHash = () => {
    //const { location } = window;
    //const paramsId = (location.hash.charAt(0) === '#' ? location.hash.slice(1).split('&') : []).map(e => e.split('=')).filter(e => e[0] === 'id');
    const queryParams = new URLSearchParams(window.location.search);
    const id = Number(queryParams.get('id') || '0');

    //if (paramsId.length > 0) {
    if (!isNaN(id)) {
      //const id = Number(paramsId[0][1]);
      //setTransferNumber(isNaN(id) ? 0 : id);
      if (id !== transferNumber) {
        console.log('uh clear and load', id);
        clearTransferBatch();
        setTransferNumber(id);

        if (id > 0) {
          loadDetail(id);
        }
      }
    }
  };

  const clearTransferBatch = () => {
    setBatch({});
    setBatchNote('');
    setBatchNumber('');
    setReferenceNumber('');
    setTransferNumber(0);
  };

  const closeToDoListInputer = () => {
    setToDoListInputerVisible(false);
  };

  const deleteToDo = (toDo: StringKAnyVPair) => {
    const idx = toDoList.findIndex(e => e.uuid === toDo.uuid);

    if (idx > -1) {
      Modal.confirm({
        centered: true,
        content: `Are you sure to delete "${toDo.label}"?`,
        title: 'Confirm',
        onOk() {
          toDoList.splice(idx, 1);
          setToDoList([ ...toDoList ]);
        },
      });
    }
  };

  const fillIdentifierWithToDo = (vd: StringKAnyVPair) => {
    const fillIdentifier = (vd: StringKAnyVPair) => {
      const vals = recvForm.getFieldsValue();

      vals.Identifer6 = vd.label;
      recvForm.setFieldsValue(vals);
      vd.used = true;
      refreshToDoList();
      if (!(selectedProduct6 && vd.label === selectedProduct6.sku)) {
        onIdentifierFilled(vd.label);
      }
    };

    const vals = recvForm.getFieldsValue();
    // console.log('v', vals);
    if (identifierLocked) {
      Modal.warning({
        centered: true,
        content: 'The identifier is locked!',
        title: 'Warning',
      });
    } else {
      if (vals.Identifer6) {
        if (vals.Identifer6 !== vd.label) {
          Modal.confirm({
            centered: true,
            content: `Do you want to replace "${vals.Identifer6}" with "${vd.label}"?`,
            title: 'Confirm',
            onOk() {
              fillIdentifier(vd);
            },
          });
        }
      } else {
        fillIdentifier(vd);
      }
    }
  };

  const generateToDoItem = (vd: StringKAnyVPair) => {
    return {
      clicked: false,
      label: '',
      used: false,
      uuid: uuid(),
      ...vd,
    };
  };

  const getProfileSettings = async () => {
    const res1 = await getProfileSettingValue('EnableLOT', '0');
    const res2 = await getProfileSettingValue('EnableUOM', '0');

    setLotEnable(res1 === '1');
    setUomEnable(res2 === '1');
  };

  const isTransferChanged = () => {
    return batch.note !== batchNote.trim() || batch.referenceNumber !== referenceNumber.trim();
  };

  const isTransferEditable = () => {
    return isTransferExisted() && batch.status === 0;
  };

  const isTransferExisted = () => {
    //return transferNumber > 0;
    return batch.warehouseBatchTransferNum > 0;
  };

  const isTransferLineAddable = () => {
    let ret = true;

    if (isTransferExisted()) {
      ret = isTransferEditable();
    }

    return ret;
  };

  const loadDetail = async (tn: number) => {
    setLockScreen(true);
    try {
      const detail = await fetchWarehouseBatchTransferDetail(tn);

      if (detail) {
        //console.log('d', detail);
        setBatch(detail);
        setBatchNote(detail.note);
        setBatchNumber(detail.batchNumber);
        setReferenceNumber(detail.referenceNumber);
        setTransferNumber(tn);
      }
    } catch(e) {
    } finally {
      setLockScreen(false);
    }
  };

  const onBatchNoteChange = (evt: any) => {
    setBatchNote(evt.target.value);
  };

  const onClickToDo = (vd: StringKAnyVPair) => {
    vd.clicked = true;
    refreshToDoList();
    fillIdentifierWithToDo(vd);
  };

  const onConfirmToDoList = (list: string[]) => {
    setToDoList(list.map(e => generateToDoItem({label: e})));
  };

  const onIdentifierFilled = async (code: string) => {
    setLockScreen(true);
    try {
      const res = await fetchProducts({uniqueCode: code});

      //console.log('res', res);
      if (res.products.length > 0) {
        const prd = res.products[0];

        onProductChange(prd);
      } else {
        setLotUomInfo(undefined);
      }
    } catch(e) {
      message.error({
        content: `Fetched product error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setLockScreen(false);
    }
  };

  const onLoadTransferBatch = (tb: StringKAnyVPair) => {
    setBatch(tb);
  };

  const onProductChange = (product: any) => {
    //console.log('ch', product);
    setSelectedProduct6(product);
    recvForm.setFieldsValue({ Identifer6: product.sku });

    if (selectedProduct6 && product.id !== selectedProduct6.id) {
      setLotUomInfo(undefined);
    }

    openProductLotUomDialog(product);
  };

  const onReferenceNumberChange = (evt: any) => {
    setReferenceNumber(evt.target.value);
  };

  const openProductLotUomDialog = (product: any) => {
    if (product && typeof product === 'object' && product.id > 0) {
      if (lotEnable || uomEnable) {
        setSelectLotUomDialogVisible(true);
      }
    } else {}
  };

  const openToDoListInputer = () => {
    setToDoListInputerVisible(true);
  };

  const refreshToDoList = () => {
    setToDoList([ ...toDoList ]);
  };

  const renderLineGrid = () => {
    return (<>
      <div
        className="mt-8 n-c-d-h-100"
        style={{height: 'calc(100vh - 380px)', maxHeight: 900}}
      >
        {/*transferNumber > 0 && batchNumber && (*/}
        {isTransferExisted() && (
          <TransferLineGrid
            editable={isTransferEditable()}
            onLoadTransfer={onLoadTransferBatch}
            transferNumber={batch.warehouseBatchTransferNum}
            version={gridVersion}
          />
        )}
      </div>
    </>);
  };

  const renderSearchForm = () => {
    return (
      <Form {...formItemLayout} form={recvForm}>
        <Row>
          <Col className="pr-4" span={12}>
            <Card className="compact-card t-source-card" title="Source">
              <Row className="mt-8">
                <FormItemLeft>
                  <Form.Item
                    name="SWarehouse6"
                    label={<FormLabel>Warehouse</FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'Please select the source warehouse!',
                      },
                    ]}
                  >
                    <SelectWarehouse
                      disabled={sourceWHLocked}
                      onChange={(warehouseRow) => {
                        setSelectedSWarehouse6(warehouseRow)
                        recvForm.setFieldsValue({ SLocation6: undefined })

                        if (selectedProduct6) {
                          setLotUomInfo(undefined);
                          openProductLotUomDialog(selectedProduct6);
                        }
                      }}
                      onlyNormal={false}
                      placeholder="Please select warehouse"
                      value={selectedSWarehouse6}
                    />
                  </Form.Item>
                </FormItemLeft>
                <LockerBox>
                  <Locker
                    onChange={val => setSourceWHLocked(val)}
                    value={sourceWHLocked}
                  />
                </LockerBox>
              </Row>
              <Row>
                <FormItemLeft>
                  <Form.Item
                    name="Identifer6"
                    label={<FormLabel>Identifier</FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'Please input Identifier!',
                      },
                    ]}
                  >
                    <SelectProduct
                      disabled={identifierLocked}
                      noControl
                      onBlurAble
                      onChange={(filename, product) => {
                        //console.log('p', product);
                        onProductChange(product);
                      }}
                    />
                  </Form.Item>
                </FormItemLeft>
                <LockerBox>
                  <Locker
                    value={identifierLocked}
                    onChange={(value) => setIdentifierLocked(value)}
                  />
                </LockerBox>
              </Row>
              {lotUomInfo && <Form.Item wrapperCol={{ ...formItemLayout.wrapperCol, offset: 8 }}>
                <Space size="large">
                  {lotEnable && <Text><Text strong>LOT#: </Text><Text>{lotUomInfo?.lotNumber}</Text></Text>}
                  {uomEnable && <Text><Text strong>UOM: </Text><Text>{lotUomInfo?.uom}</Text></Text>}
                  {uomEnable && <Text><Text strong>Rate: </Text><Text>{lotUomInfo?.uomRate}</Text></Text>}
                </Space>
              </Form.Item>}
              <Row>
                <FormItemLeft>
                  <Form.Item label={<FormLabel>Quantity</FormLabel>}>
                    <Space>
                      <Form.Item
                        name="Quantity6"
                        noStyle
                        // label={<FormLabel>Quantity</FormLabel>}
                        rules={[
                          { required: true, message: 'Please input Quantity!' },
                        ]}
                      >
                        <InputNumber disabled={quantityLock6} onChange={(value) => value && setQtyRef(Number(value))} />
                      </Form.Item>
                      {uomEnable && <Text>{`Base Qty: ${(lotUomInfo?.uomRate || 1) * Number(qtyRef || 0)}`}</Text>}
                    </Space>
                  </Form.Item>
                </FormItemLeft>
                <LockerBox>
                  <Locker
                    value={quantityLock6}
                    onChange={(value) => setQuantityLock6(value)}
                  />
                </LockerBox>
              </Row>
              <Row>
                <FormItemLeft>
                  <Form.Item
                    name="SLocation6"
                    //label={<FormLabel>Location (Location Name)</FormLabel>}
                    label={<FormLabel>Location</FormLabel>}
                    rules={[
                      { required: true, message: 'Please input Location!' },
                    ]}
                  >
                    <SearchSelect2
                      defaultSelectOneOption={true}
                      disabled={SLocationLock6}
                      form={recvForm}
                      locationQuery={lotUomInfo}
                      locationType={0}
                      onChange={(value) => console.log(value)}
                      product={selectedProduct6}
                      showPick
                      title="SLocation6"
                      //useLastValue
                      warehouseId={selectedSWarehouse6?.warehouseId}
                    />
                  </Form.Item>
                </FormItemLeft>
                <LockerBox>
                  <Locker
                    value={SLocationLock6}
                    onChange={(value) => setSLocationLock6(value)}
                  />
                </LockerBox>
              </Row>
            </Card>
          </Col>
          <Col className="pl-4" span={12}>
            <Card className="compact-card" title="Destination">
              <Row className="mt-8">
                <FormItemLeft>
                  <Form.Item
                    name="DWarehouse6"
                    label={<FormLabel>Warehouse</FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'Please select the destination warehouse!',
                      },
                    ]}
                  >
                    <SelectWarehouse
                      disabled={destWHLocked}
                      onChange={(warehouseRow) => {
                        setSelectedDWarehouse6(warehouseRow);
                        recvForm.setFieldsValue({ DLocation6: undefined });
                      }}
                      onlyNormal={false}
                      placeholder="Please select warehouse"
                      value={selectedDWarehouse6}
                    />
                  </Form.Item>
                </FormItemLeft>
                <LockerBox>
                  <Locker
                    onChange={val => setDestWHLocked(val)}
                    value={destWHLocked}
                  />
                </LockerBox>
              </Row>
              <Row>
                <FormItemLeft>
                  <Form.Item
                    name="DLocation6"
                    //label={<FormLabel>Location (Location Name)</FormLabel>}
                    label={<FormLabel>Location</FormLabel>}
                    rules={[
                      {
                        required: true,
                        message: 'Please input Location!',
                      },
                    ]}
                  >
                    <SearchSelect2
                      disabled={DLocationLock6}
                      form={recvForm}
                      locationQuery={lotUomInfo}
                      locationType={0}
                      onChange={(value) => console.log(value)}
                      optionVersion={1}
                      product={selectedProduct6}
                      showPick={false}
                      title="DLocation6"
                      //useLastValue
                      warehouseId={selectedDWarehouse6?.warehouseId}
                    />
                  </Form.Item>
                </FormItemLeft>
                <LockerBox>
                  <Locker
                    value={DLocationLock6}
                    onChange={(value) => setDLocationLock6(value)}
                  />
                </LockerBox>
              </Row>
              <Row>
                <FormItemLeft>
                  <Form.Item
                    name="LineNote"
                    label={<FormLabel>Line Note</FormLabel>}
                    rules={[
                    ]}
                  >
                    <Input
                      disabled={lineNotedLocked}
                      placeholder="Input line note here"
                    />
                  </Form.Item>
                </FormItemLeft>
                <LockerBox>
                  <Locker
                    value={lineNotedLocked}
                    onChange={(value) => setLineNoteLocked(value)}
                  />
                </LockerBox>
              </Row>
              <Row className="mb-8 pl-8 pr-8" justify="space-between">
                <span
                  className="inline-block"
                  style={{ width: 128 }}
                />
                <Button
                  disabled={!isTransferLineAddable()}
                  onClick={saveLine}
                  type="primary"
                >
                  <PlusOutlined />
                  Add
                </Button>
                {batch.totalLine > 0 ? (
                  <ExportCSV
                    columns={exportColumns}
                    data={mapCsvData(batch.lines)}
                    scope={batch.batchNumber}
                  />
                ) : (
                  <span
                    className="inline-block"
                    style={{ width: 128 }}
                  />
                )}
              </Row>
            </Card>
          </Col>
        </Row>
      </Form>
    );
  };

  const renderSider = () => {
    return (
      <div className="ant-card-bordered br-10 ml-8 p-8">
        <Row align="middle" className="bb-solid-f0 pb-8" justify="space-between">
          {isErrorExist(batch) ? (
            <Tooltip
              placement="top"
              //title={typeof row.error === 'string' ? row.error.replace(/\n/g, '<br />') : row.error}
              title={batch.error}
              trigger={['hover', 'click']}
            >
              <InfoCircleOutlined className="text-error1 fs-22" />
            </Tooltip>
          ) : (
            <span>&nbsp;</span>
          )}
          <Dropdown
            overlay={(
              <Menu>
                <Menu.Item disabled={!isTransferEditable()} onClick={() => submitBatch()}  key="submit-batch-dd-menu">
                  <Label className={isTransferEditable() ? 'label-primary clickable' : 'label-disabled'}>
                    <CheckOutlined />
                    &nbsp;Submit
                  </Label>
                </Menu.Item>
              </Menu>
            )}
          >
            <Button className="h-28 p-3-6">
              <EllipsisOutlined />
            </Button>
          </Dropdown>
        </Row>
        <Row align="middle" className="bb-dashed pb-4 pt-4">
          <FormLabel>Batch Number</FormLabel>
          {isTransferExisted() && <Label className="label-grey ml-4">{batchNumber}</Label>}
        </Row>
        <Row className="pt-4">
          <FormLabel>Reference Number</FormLabel>
          <Input
            allowClear
            disabled={!isTransferEditable()}
            onChange={onReferenceNumberChange}
            value={referenceNumber}
          />
        </Row>
        <div className="bb-dashed pb-8 pt-4">
          <FormLabel>Group Note</FormLabel>
          <Input.TextArea
            allowClear
            disabled={!isTransferEditable()}
            onChange={onBatchNoteChange}
            rows={3}
            value={batchNote}
          >
          </Input.TextArea>
          <Row className="mt-8" justify="end">
            <SecondaryButton
              disabled={!(isTransferEditable() && isTransferChanged())}
              onClick={saveBatch}
            >
              <SaveOutlined />
              Save
            </SecondaryButton>
          </Row>
        </div>
        <div className="pt-8">
          <Row align="middle" className="bb-solid-f0 pb-8" justify="space-between">
            <FormLabel>To do list</FormLabel>
            <InfoButton
              className="p-4-8"
              disabled={!isTransferLineAddable()}
              onClick={openToDoListInputer}
            >
              <PlusOutlined />
            </InfoButton>
          </Row>
          <div
            className="y-scrollable"
            style={{height: 'calc(100vh - 523px)'}}
          >
            {renderToDoList()}
          </div>
        </div>
      </div>
    );
  };

  const renderToDoList = () => {
    return toDoList.map(e => (
      <Row
        align="middle"
        className="c-list-item p-4"
        justify="space-between"
        key={e.uuid}
      >
        <div
          className={toDoItemClass(e)}
          onClick={() => onClickToDo(e)}
          style={{width: 'calc(100% - 24px)'}}
        >
          {e.label}
        </div>
        <Dropdown
          overlay={(
            <Menu>
              <Menu.Item key="del-todo-item" onClick={() => deleteToDo(e)}>
                <Label className="label-danger clickable">
                  <CheckOutlined />
                  &nbsp;Delete
                </Label>
              </Menu.Item>
            </Menu>
          )}
        >
          <Button className="h-24 p-1-4">
            <EllipsisOutlined />
          </Button>
        </Dropdown>
      </Row>
    ));
  };

  const saveBatch = async () => {
    setLockScreen(true);
    try {
      const rn = referenceNumber.trim();
      const bn = batchNote.trim();
      const bd = {
        ReferenceNumber: rn,
        Note: bn,
      };
      const res = await editWarehouseBatchTransfer(batch.warehouseBatchTransferNum, bd);

      if (res) {
        setBatch({
          ...batch,
          note: bn,
          referenceNumber: rn,
        });
        setBatchNote(bn);
        setReferenceNumber(rn);
        message.success({
          content: `Saved successfully`,
          duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
        });
      }
    } catch(e) {
      message.error({
        content: `Saved error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setLockScreen(false);
    }
  };

  const saveLine = async () => {
    const formParam = await recvForm.validateFields();
    const param = {
      FromWarehouseNum: formParam.SWarehouse6.warehouseNum,
      FromLocationNum: formParam.SLocation6,
      ToWarehouseNum: formParam.DWarehouse6.warehouseNum,
      ToLocationNum: formParam.DLocation6,
      // @ts-ignore
      FulfillmentProductNum: selectedProduct6.fulfillmentProductNum,
      // @ts-ignore
      SKU: selectedProduct6.sku,
      LotNumber: '',
      Uom: 'EA',
      UomRate: 1,
      Quantity: Number(formParam.Quantity6) || 0,
      Note: formParam.LineNote,
    };
    //let tn = transferNumber;
    let tn = batch.warehouseBatchTransferNum || 0;

    if ((lotEnable || uomEnable) && !lotUomInfo) {
      openProductLotUomDialog(selectedProduct6);
      return;
    }
    // console.log('fp', formParam);tryClearLineForm(formParam);return;

    if (lotUomInfo) {
      // @ts-ignore
      param.LotNumber = lotUomInfo.lotNumber || '';
      // @ts-ignore
      param.Uom = lotUomInfo.uom || 'EA';
      // @ts-ignore
      param.UomRate = lotUomInfo.uomRate || 1;
    }

    setLockScreen(true);

    if (tn === 0) {
      try {
        const res = await addWarehouseBatchTransfer();
        let added = false;

        if (res && typeof res === 'object') {
          console.log('res', res);
          if (res.code === HTTP_STATUS_OK && res.isSuccess) {
            tn = res.data.warehouseBatchTransferNum;
            added = true;
          }
        }

        if (!added) {
          message.error({
            content: `Adding transfer item failed`,
            duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
          });
          setLockScreen(false);
          return;
        }
      } catch(e) {
        message.error({
          content: `Added transfer item error: ${e}`,
          duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
        });
        setLockScreen(false);
        return;
      }
    }

    //console.log('f', formParam, lotUomInfo, param);
    try {
      const res = await addWarehouseBatchTransferLine(tn, param);

      //console.log('res', res);
      if (res && typeof res === 'object') {
        if (res.code === HTTP_STATUS_OK && res.isSuccess) {
          message.success({
            content: 'Added successfully',
            duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
          });

          tryClearLineForm(formParam);
          //if (transferNumber === 0) {
          if (batch.warehouseBatchTransferNum === undefined) {
            editTransferBatch(history, tn);
          } else {
            setGridVersion(gridVersion + 1);
          }
        }
      }
    } catch(e) {
      /*// @ts-ignore
      let msg = (e && typeof e === 'object' && e.response && e.response.data && typeof e.response.data === 'string') ? e.response.data : `${e}`;

      message.error({
        content: `Added line error: ${msg}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });*/
    } finally {
      setLockScreen(false);
    }
  };

  const submitBatch = () => {
    submitTransferBatch(
      batch,
      setLockScreen,
      (tb: StringKAnyVPair) => {
        batch.status = tb.status;
        batch.updateBy = tb.updateBy;
        batch.updateDate = tb.updateDate;
        setBatch({ ...batch });
        message.success({
          content: 'Submitted successfully',
          duration: COMMON_MSG_DEFAULT_DISPLAY_DURATION,
        });
      },
    );
  };

  const toDoItemClass = (vd: StringKAnyVPair) => {
    const cls = ['text-clickable'];

    if (vd.used) {
      cls.push('text-green');
    } else if (vd.clicked) {
      cls.push('text-blue');
    } else {
      //cls.push('text-hover-blue');
    }

    return cls.join(' ');
  };

  const tryClearLineForm = (fvObj: StringKAnyVPair) => {
    if (!SLocationLock6) fvObj.SLocation6 = undefined;
    if (!quantityLock6) fvObj.Quantity6 = undefined;
    if (!DLocationLock6) fvObj.DLocation6 = undefined;
    if (!lineNotedLocked) fvObj.LineNote = undefined;
    if (!sourceWHLocked) {
      fvObj.SWarehouse6 = undefined;
      setSelectedSWarehouse6(undefined);
    }
    if (!destWHLocked) {
      fvObj.DWarehouse6 = undefined;
      setSelectedDWarehouse6(undefined);
    }
    if (!identifierLocked) {
      fvObj.Identifer6 = '';
      setSelectedProduct6(undefined);
      setLotUomInfo(undefined);
    }

    console.log('vo', fvObj);
    recvForm.setFieldsValue(fvObj);
  };

  React.useEffect(() => {
    if (!inited) {
      getProfileSettings();
      setInited(true);
    }

    checkBatchNumberFromHash();
  }, [
    checkBatchNumberFromHash,
    inited,
  ]);

  return (<>
    <HeaderTitle breadcrumb={['Warehouse Transfer', 'Initiate from WMS', 'Add / Update']} />
    <CardSection>
      <Layout className="bg-no">
        <Layout.Content>
          {renderSearchForm()}
          {renderLineGrid()}
        </Layout.Content>
        <Layout.Sider className="bg-no" width={210}>
          {renderSider()}
        </Layout.Sider>
      </Layout>
    </CardSection>
    {(selectLotUomDialogVisible && selectedProduct6) && (
      <SelectLotUomDialog
        uomEnable={uomEnable}
        lotEnable={lotEnable}
        noNew={true}
        timeZone=''
        onHide={()=>{
          setSelectLotUomDialogVisible(false)
        }}
        onOk={(data)=>{
          setLotUomInfo(data)
          setSelectLotUomDialogVisible(false)
        }}
        product={selectedProduct6}
      />
    )}
    {toDoListInputerVisible && (
      <ToDoListInputer
        centered
        onCancel={closeToDoListInputer}
        onConfirmToDoList={onConfirmToDoList}
        visible={toDoListInputerVisible}
      />
    )}
    {lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default WHTransferReceive;
